export function SectionHeaderWithAction({
  text,
  button,
}: {
  text: string;
  button: React.JSX.Element;
}) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-zinc-900 font-medium">{text}</span>
      {button}
    </div>
  );
}
